<template>
    <div class="layout align-center justify-center wrap container text-xs-center">
        <v-flex class="xs12 sm12 md12">
            <div>
                <v-card class="card card-pricing card-plain">
                    <div class="m-portlet__head" style="border-bottom: 1px solid #ebedf2;">
                        <div class="m-portlet__head-caption">
                            <div class="m-portlet__head-title" style="width: 100%">
                                <h3 class="m-portlet__head-text" style="float: initial;text-align: start;padding: 30px;">
                                    Rhino Plugin
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__body" style="padding: 30px;text-align: start">
                        <div class="row">

                            <div class="col-md-12">
                                <div class="m-section">
                                    <h3 class="m-section__heading">
                                        Download Licens3D plugin for <a href="https://www.rhino3d.com/es/download">Rhino 6</a>:
                                    </h3>
                                    <div class="m-section__content">
                                        <a href="<%- url %>" class="btn btn-primary m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill">
                                            <span>Get Plugin</span>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <div class="m-section">
                                    <h3 class="m-section__heading">
                                        Installation
                                    </h3>
                                    <div class="m-section__content">
                                        <ol>
                                            <li>Go to the Rhino Plug-in Manager (write PlugInManager in the console prompt).</li>
                                            <li>Click the "Install..." button and select the Licens3d Plugin (licens3d.rhp).</li>
                                            <li>Verify that the Activated check is checked and click "Accept".</li>
                                            <li>Write "Licens3d" in the console prompt to view the plug-in interface and situate it in a desired place within the Rhino GUI.</li>
                                            <li>Log-in into your account to browse your files.</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </v-card>
            </div>
        </v-flex>
    </div>
</template>

<script>
    import {  VIcon, VFlex, VCard, VBtn } from 'vuetify/lib';
    export default {
        name: "Rhino",
        components: {
            VIcon,
            VFlex,
            VCard,
            VBtn
        },
    }
</script>

<style scoped>
    h5, .h5 {
        font-size: 1.25rem;
    }
    h6, .h6 {
        font-size: 1rem;
    }
</style>